import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Class from '../components/Class';
import Message from '../components/Message';
import Loader from '../components/Loader';
import Paginate from '../components/Paginate';
//import ClassCarousel from '../components/ClassCarousel'
// import Meta from '../components/Meta'
import { listClasses } from '../actions/classActions';
import {
  Jumbotron,
  Container,
  // Button,
  // Card,
  // CardDeck,
  Row,
  Col,
} from 'react-bootstrap';

const ClassesScreen = ({ match }) => {
  const keyword = match.params.keyword;

  const pageNumber = match.params.pageNumber || 1;

  const dispatch = useDispatch();

  const classList = useSelector(state => state.classList);
  const { loading, error, classes, page, pages } = classList;

  useEffect(() => {
    dispatch(listClasses(keyword, pageNumber));
  }, [dispatch, keyword, pageNumber]);

  return (
    <>
      <Jumbotron className='jumbotron2'>
        <Container>
          <h1>Book a class today</h1>
        </Container>
      </Jumbotron>
      {loading ? (
        <Loader />
      ) : error ? (
        <Message variant='danger'>{error}</Message>
      ) : (
        <>
          <Row>
            {classes.map(classs => (
              <Col sm={12} md={6} lg={5} xl={4}>
                <Class classs={classs} />
              </Col>
            ))}
          </Row>
          <Paginate
            pages={pages}
            page={page}
            keyword={keyword ? keyword : ''}
          />
        </>
      )}
    </>
  );
};

export default ClassesScreen;

// {/* <CardDeck>
//   <Card>
//     <Card.Img variant='top' src='holder.js/100px160' />
//     <Card.Body>
//       <Card.Title>Cardio Class</Card.Title>
//       <Card.Text>
//         Class: Cardio with Cacey
//         <br />
//         Coach: Casey Sunshine
//         <br />
//         Class Type: Group Cardio
//         <br />
//         Spots Available: 5/20
//         <br />
//         Time: 2pm Friday
//         <br />
//         Gym: The Hot Box
//         <br />
//         Price: $35 per Hour
//         <br />
//         Address: 1234 Real St.
//         <br />
//         Denver, CO 80203
//         <br />
//       </Card.Text>
//     </Card.Body>
//     <Card.Footer>
//       <Button block>Book Class</Button>
//     </Card.Footer>
//   </Card>
//   <Card>
//     <Card.Img variant='top' src='holder.js/100px160' />
//     <Card.Body>
//       <Card.Title>Crossfit</Card.Title>
//       <Card.Text>
//         Class: Crushin it Old School
//         <br />
//         Coach: Beef McCheese
//         <br />
//         Class Type: Weight Training
//         <br />
//         Spots Available: 15/20
//         <br />
//         Time: 6pm Friday
//         <br />
//         Gym: Planet Crush
//         <br />
//         Price: $20 Drop-ins
//         <br />
//         Address: 1234 Real St.
//         <br />
//         Denver, CO 80203
//         <br />
//       </Card.Text>
//     </Card.Body>
//     <Card.Footer>
//       <Button block>Book Class</Button>
//     </Card.Footer>
//   </Card>
//   <Card>
//     <Card.Img variant='top' src='holder.js/100px160' />
//     <Card.Body>
//       <Card.Title>Dance Cardio</Card.Title>
//       <Card.Text>
//         Class: Zumba
//         <br />
//         Coach: J Star
//         <br />
//         Class Type: Cardio Dance
//         <br />
//         Spots Available: 2/20
//         <br />
//         Time: 2pm Wednesday
//         <br />
//         Gym: DANCETYME
//         <br />
//         Price: $10 Drop ins
//         <br />
//         Address: 1234 Real St.
//         <br />
//         Denver, CO 80203
//         <br />
//       </Card.Text>
//     </Card.Body>
//     <Card.Footer>
//       <Button block>Book Class</Button>
//     </Card.Footer>
//   </Card>
// </CardDeck> */}
